export const GET_ALERT_SETTINGS_REQUEST = 'GET_ALERT_SETTINGS_REQUEST';
export const GET_ALERT_SETTINGS_SUCCESS = 'GET_ALERT_SETTINGS_SUCCESS';
export const GET_ALERT_SETTINGS_ERROR = 'GET_ALERT_SETTINGS_ERROR';
export const CREATE_ALERT_SETTING_REQUEST = 'CREATE_ALERT_SETTING_REQUEST';
export const CREATE_ALERT_SETTING_SUCCESS = 'CREATE_ALERT_SETTING_SUCCESS';
export const CREATE_ALERT_SETTING_ERROR = 'CREATE_ALERT_SETTING_ERROR';
export const DELETE_ALERT_SETTING_REQUEST = 'DELETE_ALERT_SETTING_REQUEST';
export const DELETE_ALERT_SETTING_SUCCESS = 'DELETE_ALERT_SETTING_SUCCESS';
export const DELETE_ALERT_SETTING_ERROR = 'DELETE_ALERT_SETTING_ERROR';
export const UPDATE_ALERT_SETTING_REQUEST = 'UPDATE_ALERT_SETTING_REQUEST';
export const UPDATE_ALERT_SETTING_SUCCESS = 'UPDATE_ALERT_SETTING_SUCCESS';
export const UPDATE_ALERT_SETTING_ERROR = 'UPDATE_ALERT_SETTING_ERROR';
